<template>
    <div>
        <div class="tasks-bar-holder" @click="watch()" style="cursor: pointer">
            <div class="tasks-bar-subject">
                <div style="width: 100%">
                    {{ task.humanName }}
                </div>
                <div :class="task.humanStatus.class">
                    {{ task.humanStatus.label }}
                </div>
            </div>

            <div v-if="task.status === 'RUNNING'" style="margin-top: 5px">
                <div v-for="item in progress">
                    <div class="progress" style="margin-bottom: 5px">
                        <div class="progress-bar progress-bar-striped active" :style="{ width: item.percentage + '%' }">
                            <span v-if="item.humanName">{{ item.humanName }} - </span>
                            <span>{{ item.percentage.toFixed(0) }}%</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tasks-bar-footer text-muted" style="display: flex; margin-bottom: 10px">
                <div style="text-align: right; width: 100%" :title="task.createdAt | datetime_with_year">
                    {{ task.createdAt | timeago }}
                </div>
            </div>
        </div>
        <div class="tasks-bar-bottom" v-if="task.output">
            <div v-if="loading">
                Carregando...
            </div>
            <div v-if="!loading">
                <component :is="task.alias" :task="task"></component>
            </div>
        </div>
    </div>
</template>
<style>
    .tasks-bar-footer {
        margin-top: 12px;
        font-size: 13px;
    }

    .tasks-bar-buttons {
        display: flex;
        width: 100%;
        padding: 0;
    }

    .tasks-bar-buttons > a {
        width: 100%;
        flex-grow: 1;
        padding: 10px 12px;
        border: 1px solid #eee;
        border-left: none;
        border-bottom: none;
        text-align: center;
        background-color: #fbfbfb;
    }

    .tasks-bar-buttons > a:last-of-type {
        border-right: none;
    }

    .tasks-bar-holder {
        text-decoration: none;
        color: black;
        display: block;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 10px;
    }

    .tasks-bar-holder:hover {
        text-decoration: none;
    }

    .tasks-bar-subject {
        font-weight: bold;
        font-size: 13px;
        display: flex;
    }

    .tasks-bar-content {
        margin: 0;
        padding: 0;
        font-size: 13px;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        display: block;
        white-space: nowrap;
    }

    .tasks-bar-content * {
        display: inline-block;
        font-size: 13px;
        margin: 0;
        padding: 0;
    }
</style>
<script>
    const { gql } = require('@apollo/client/core')
    const queueClientWs = require('sci/helpers/queue-client-ws')
    const queueClient = require('sci/helpers/queue-client')
    const bus = require('sci/std/bus')

    const { statusesNames, find } = require('./helpers')

    const TestV1 = require('./InlineOutputs/TestV1.vue')
    const TestV2 = require('./InlineOutputs/TestV2.vue')
    const ExportCustomersV1 = require('./InlineOutputs/ExportCustomersV1.vue')
    const ExportPropertiesV1 = require('./InlineOutputs/ExportPropertiesV1.vue')

    const progressNames = {
        'TestV2': {
            'other': 'Teste'
        },
        'TestV1': {}
    }

    export default {
        props: {
            task: {
                type: Object,
                twoWay: true
            },
            taskStatusChanged: {
                type: Function
            },
            closeDropdown: {
                type: Function
            }
        },
        components: {
            TestV1,
            TestV2,
            ExportCustomersV1,
            ExportPropertiesV1
        },
        data () {
            return {
                loading: false
            }
        },
        computed: {
            progress () {
                return this.task.progress.map((progress) => {
                    progress.humanName = null

                    if (progress.alias === '$default') {
                        return progress
                    }

                    if (progressNames[this.task.alias]) {
                        progress.humanName = progressNames[this.task.alias][progress.alias] || null
                    }

                    return progress
                })
            }
        },
        methods: {
            refresh () {
                if (this.loading) {
                    return
                }

                this.loading = true

                find(this.task.id).then((res) => {
                    this.task = res
                    this.loading = false
                })
            },

            watch () {
                this.closeDropdown()

                bus.$emit('queue:watch', this.task.id)
            },
        },
        init () {
            this.$subscription = null
        },
        ready () {
            const self = this
            if (this.task.status === 'WAITING' || this.task.status === 'RUNNING') {
                this.$subscription = queueClientWs().subscribe({
                    query: gql`
                    subscription($id: Long!) {
                        watchTaskById(taskId: $id) {
                            id
                            name

                            ... on TaskProgressUpdatedEvent {
                              progress {
                                alias
                                percentage
                              }
                            }
                        }
                    }
                `,
                    variables: {
                        id: this.task.id
                    }
                }).subscribe({
                    next(event) {
                        const data = event.data.watchTaskById

                        switch (data.name) {
                            case "progress-updated":
                                if (self.task.progress && self.task.progress.some(_ => _.alias === data.progress.alias)) {
                                    for (let p of self.task.progress) {
                                        if (p.alias === data.progress.alias) {
                                            p.percentage = data.progress.percentage
                                        }
                                    }
                                } else {
                                    self.task.progress.push(data.progress)
                                }
                                break;
                            case "task-started":
                                self.task.status = 'RUNNING';
                                self.task.humanStatus = statusesNames[self.task.status]
                                break;
                            case "task-finished":
                                self.task.status = 'DONE';
                                self.task.humanStatus = statusesNames[self.task.status]
                                self.refresh()
                                break;
                            case "task-failed":
                                self.task.status = 'FAILED';
                                self.task.humanStatus = statusesNames[self.task.status]
                                break;
                            case "task-aborted":
                                self.task.status = 'ABORTED';
                                self.task.humanStatus = statusesNames[self.task.status]
                                break;
                            case "task-cancelled":
                                self.task.status = 'CANCELLED';
                                self.task.humanStatus = statusesNames[self.task.status]
                                break;
                        }
                    },
                    error(err) {
                        console.error({err})
                    },
                    complete() {
                        console.debug("complete")
                    }
                })
            }
        },
        destroyed () {
            // console.log('destroyed', this.task)
            if (this.$subscription) {
                this.$subscription.unsubscribe()
            }
        },
        watch: {
            task: {
                deep: true,
                handler (newVal, oldVal) {
                    if (newVal.status !== oldVal.status) {
                        if (this.taskStatusChanged) {
                            this.taskStatusChanged(newVal)
                        }
                    }
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Task.vue?5faa8f1e